import { render } from "./HeaderNotifications.vue?vue&type=template&id=12465790&scoped=true"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js"

import "./HeaderNotifications.vue?vue&type=style&index=0&id=12465790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12465790"]])

export default __exports__